import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import DashboardClient from "@/pages/DashboardClient";
import DashboardHelper from "@/pages/DashboardHelper";
import TaskNew from "@/pages/TaskNew";
import TaskFeed from "@/pages/TaskFeed";
import TaskDetail from "@/pages/TaskDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Messages from "@/pages/Messages";
import History from "@/pages/History";
import Profile from "@/pages/Profile";
import Referral from "@/pages/Referral";
import Badges from "@/pages/Badges";
import Help from "@/pages/Help";
import HelperApply from "@/pages/HelperApply";
import Notifications from "@/pages/Notifications";
import Admin from "@/pages/Admin";
import Ideas from "@/pages/Ideas";
import Calendar from "@/pages/Calendar";
import Gear from "@/pages/Gear";

function Private({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-navy">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster richColors position="top-center" />
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/idees" element={<Ideas />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />

            <Route path="/dashboard/client" element={<Private role="client"><DashboardClient /></Private>} />
            <Route path="/dashboard/helper" element={<Private role="helper"><DashboardHelper /></Private>} />
            <Route path="/helper/apply" element={<Private role="helper"><HelperApply /></Private>} />
            <Route path="/tasks/new" element={<Private role="client"><TaskNew /></Private>} />
            <Route path="/tasks" element={<Private><TaskFeed /></Private>} />
            <Route path="/tasks/:id" element={<Private><TaskDetail /></Private>} />
            <Route path="/payment/success" element={<Private><PaymentSuccess /></Private>} />
            <Route path="/messages/:taskId" element={<Private><Messages /></Private>} />
            <Route path="/history" element={<Private><History /></Private>} />
            <Route path="/profile" element={<Private><Profile /></Private>} />
            <Route path="/referral" element={<Private><Referral /></Private>} />
            <Route path="/calendar" element={<Private><Calendar /></Private>} />
            <Route path="/equipement" element={<Private role="helper"><Gear /></Private>} />
            <Route path="/badges" element={<Private role="helper"><Badges /></Private>} />
            <Route path="/help" element={<Private><Help /></Private>} />
            <Route path="/notifications" element={<Private><Notifications /></Private>} />
            <Route path="/admin" element={<Private role="admin"><Admin /></Private>} />

            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}
